import React from 'react';
import { useTranslation } from 'react-i18next';
import { TriangleAlert } from 'lucide-react';
import { getLanguageDirection } from '../../i18n/config';

const NoKnowledgebaseState: React.FC = () => {
    const { t, i18n } = useTranslation();

    return (
        <div
            dir={getLanguageDirection(i18n.language)}
            className="p-8 flex flex-col items-center justify-center text-center h-full m-2 rounded-2xl border border-dashed border-border bg-transparent"
        >
            <TriangleAlert size={48} className="text-muted-foreground mb-4" />
            <h6 className="text-base font-semibold text-foreground mb-1">
                {t('common.knowledgebase.pleaseSelectCase')}
            </h6>
            <p className="text-sm text-muted-foreground max-w-[450px]">
                {t('common.knowledgebaseDialogs.selectCaseToView')}
            </p>
        </div>
    );
};

export default NoKnowledgebaseState;
